import { HttpInterceptorFn } from "@angular/common/http";
import { EnvironmentProviders, Injectable, InjectionToken, Provider, inject, makeEnvironmentProviders } from "@angular/core";

export interface BffSessionAuthConfig {
  loginUrl: string;
  logoutUrl: string;
}

export const BFF_SESSION_AUTH_CONFIG = new InjectionToken<BffSessionAuthConfig>("BFF_SESSION_AUTH_CONFIG");

export type LoginPrompt = "login" | "select_account";

@Injectable({ providedIn: "root" })
export class BffSessionAuthService {
  private readonly config = inject(BFF_SESSION_AUTH_CONFIG);

  redirectToLogin(returnTo = window.location.href, prompt?: LoginPrompt): void {
    const url = new URL(this.config.loginUrl, window.location.origin);
    url.searchParams.set("return_to", returnTo);
    if (prompt) {
      url.searchParams.set("prompt", prompt);
    } else {
      url.searchParams.set("prompt", "login");
    }
    window.location.assign(url.toString());
  }

  async signOut(): Promise<void> {
    await fetch(this.config.logoutUrl, {
      method: "POST",
      credentials: "include",
    });
  }
}

export function provideBffSessionAuth(config: BffSessionAuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: BFF_SESSION_AUTH_CONFIG, useValue: config } satisfies Provider]);
}

export function bffSessionApiInterceptor(apiBaseUrl?: string): HttpInterceptorFn {
  return (req, next) => {
    const isApiRequest = !apiBaseUrl || req.url.startsWith(apiBaseUrl);
    const request = isApiRequest ? req.clone({ withCredentials: true }) : req;
    return next(request);
  };
}
